<template>
  <v-card>
    <v-card-text>
      <form
        id="branchSearchForm"
        autocomplete="off"
        novalidate
        :style="{ margin: '-0.25rem' }"
        @submit.prevent="handleSubmit"
      >
        <v-layout wrap>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('branch_name') }}</label>
            <input v-model="form.branchName" type="text" />
          </v-flex>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('phone no.') }}</label>
            <input v-model="form.phoneNumber" type="tel" />
          </v-flex>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('Subdistrict') }}</label>
            <ThaiAddressInput
              v-model="form.subdistrict"
              type="district"
              @select="handleAddressSelect"
            />
          </v-flex>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('District') }}</label>
            <ThaiAddressInput v-model="form.district" type="amphoe" @select="handleAddressSelect" />
          </v-flex>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('Province') }}</label>
            <ThaiAddressInput
              v-model="form.province"
              type="province"
              @select="handleAddressSelect"
            />
          </v-flex>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('Postcode') }}</label>
            <ThaiAddressInput
              v-model="form.postcode"
              type="zipcode"
              @select="handleAddressSelect"
            />
          </v-flex>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('latitude') }}</label>
            <input v-model="form.latitude" type="number" />
          </v-flex>
          <v-flex xs12 md4 class="form-control pa-1">
            <label class="d-block">{{ $t('longitude') }}</label>
            <input v-model="form.longitude" type="number" />
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn @click="clear">{{ $t('Clear Search') }}</v-btn>
      <v-btn type="submit" form="branchSearchForm" color="primary">
        <v-icon>search</v-icon>
        {{ $t('Search') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ThaiAddressInput from '@/components/elements/ThaiAddressInput'

export default {
  components: { ThaiAddressInput },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        branchName: '',
        phoneNumber: '',
        subdistrict: '',
        district: '',
        province: '',
        postcode: '',
        latitude: '',
        longitude: ''
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.form = { ...this.form, ...value }
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('input', { ...this.form, page: 1 })
    },
    clear() {
      this.$emit('input', { page: 1, limit: 10 })
    },
    handleAddressSelect(address) {
      this.form = {
        ...this.form,
        subdistrict: address.district,
        district: address.amphoe,
        province: address.province,
        postcode: address.zipcode
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/superrich/branch/Search.vue